export default [ '$rootScope', '$stateParams', '$state', 'propertiesService', 'encryptService', ($rootScope, $stateParams, $state, propertiesService, encryptService) => {
    const properties = {};

    properties.list = undefined;

    properties.load = () => {
        return propertiesService.findAll(-1).then(response => properties.list = response);
    };

    properties.find = () => {
        return new Promise ((resolve, reject) => {
            if (!properties.list){
                return properties.load().then(()=>{
                    if (!$rootScope.currentProperty){
                        let propertyId = 0;
                        var propertyExists = {};

                        var storedProperty = localStorage.getItem('property');


                        if ( !storedProperty || (storedProperty && storedProperty.length <= 3) ) {

                            if (properties.list.length > 0) {
                                propertyExists = find(properties.list, { id: parseInt(propertyId) });
                                if (!propertyExists) {
                                    propertyId = properties.list[0].id;
                                }
                            }

                            if (propertyId) {
                                // Encrypt and set hotelId
                                return encryptService.encrypt(propertyId.toString()).then(encrypted => {
                                    localStorage.setItem('property', encrypted.data);
                                    return propertiesService.findById(propertyId).then(response => {
                                        $rootScope.currentProperty = response;
                                        resolve();
                                    });
                                });
                            }
                        } else if ( storedProperty ) {
                            return encryptService.decrypt(storedProperty.toString()).then(decrypted => {
                                propertyId = parseInt(decrypted.data.join(''), 10);

                                propertyExists = find(properties.list, { id: parseInt(propertyId) });

                                if (properties.length > 0 && !propertyExists) {
                                    propertyId = properties.list[0].id;
                                }

                                if (propertyId) {
                                    // Encrypt and set hotelId
                                    return encryptService.encrypt(propertyId.toString()).then(encrypted => {
                                        localStorage.setItem('property', encrypted.data);
                                        return propertiesService.findById(propertyId).then(response => {
                                            $rootScope.currentProperty = response;
                                            resolve();
                                        });
                                    });
                                }
                            });
                        }
                        reject();
                    }else{
                        resolve();
                    }
                });
            }
        });

    };

    return properties;
}];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/property.load.service.js